class ResponsiveTable {
  constructor() {
    this.tables = document.querySelectorAll('table.contenttable');
    this.tables.forEach(table => {
      const wrapper = document.createElement('div');
      wrapper.className = 'table-responsive';

      // Insert the wrapper before the table in the DOM
      table.parentNode.insertBefore(wrapper, table);

      // Move the table into the wrapper
      wrapper.appendChild(table);
    });
  }
}

export default ResponsiveTable;
